import { InputText } from 'components';
import { Loading } from 'components';
import { PopupWraper } from 'components';
import { Button, InputWraper } from 'modules';
import { Icon } from 'components/icon';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MainRouteKeys } from 'routes/enums';
import { useGetBalanceQuery } from 'services';

const BalanceManagementFeatures = (): JSX.Element => {
  const navigate = useNavigate();
  const [isShowBankSelectModal, setIsShowBankSelectModal] =
    useState<boolean>(false);

  const { data, isLoading } = useGetBalanceQuery();

  const nomorlizeBalance = (balance: number) => {
    return Number(balance).toLocaleString('vi-VN') + ' đ';
  };

  return (
    <div className='container-fluid balance-management'>
      <Loading isLoading={isLoading}>
        <div className='balance-management__form'>
          <div className='balance-management__balance'>
            <InputWraper
              label='Số dư'
              component={InputText}
              inputProps={{
                value: data ? nomorlizeBalance(data.balance) : '',
                name: 'balance',
                isDisabled: true,
                onChange: () => {},
                onTouched: () => {},
              }}
            />
          </div>

          <div className='balance-management__action'>
            <Button
              className='balance-management__action-button'
              label={'Nạp điểm'}
              type='button'
              buttonType='success'
              icon={() => <Icon.Deposit size={18} />}
              onClick={() => navigate(MainRouteKeys.TopUp)}
            />

            <Button
              className='balance-management__action-button'
              label={'Chuyển điểm'}
              type='button'
              buttonType='success'
              icon={() => <Icon.Transfer size={18} />}
              onClick={() => navigate(MainRouteKeys.Transfers)}
            />
            <Button
              className='balance-management__action-button'
              label={'Chuyển tiền trên web'}
              type='button'
              buttonType='success'
              icon={() => <Icon.BankBuilding size={18} />}
              onClick={() => setIsShowBankSelectModal(true)}
            />
            <Button
              className='balance-management__action-button'
              label={'Chuyển tiền với chứng từ'}
              type='button'
              buttonType='success'
              icon={() => <Icon.ClaimIcon size={18} />}
              onClick={() =>
                navigate(MainRouteKeys.BidvTransferWithEvidenceCreate)
              }
            />
            <Button
              className='balance-management__action-button'
              label={'Rút điểm'}
              type='button'
              buttonType='success'
              icon={() => <Icon.Withdraw size={18} />}
              onClick={() => navigate(MainRouteKeys.CreateRequestWithdraw)}
            />
          </div>
        </div>
      </Loading>

      {isShowBankSelectModal && (
        <PopupWraper
          center
          title='Chọn nguồn tiền chuyển khoản'
          onClose={() => setIsShowBankSelectModal(false)}
        >
          <div
            style={{
              padding: '16px 8px',
              display: 'flex',
              gap: 16,
              justifyContent: 'center',
            }}
          >
            {/* <div
              onClick={() => {
                setIsShowBankSelectModal(false);
                navigate(MainRouteKeys.TransfersToBank);
              }}
              style={{
                cursor: 'pointer',
                border: '2px solid #353570',
                borderRadius: 12,
                padding: '24px 32px',
                textAlign: 'center',
                minWidth: 140,
                background: '#1d1d42',
                transition: 'border-color 0.2s',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.borderColor = '#4caf50')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.borderColor = '#353570')
              }
            >
              <img
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: 8,
                  background: '#0066CC',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 12px',
                  fontSize: 18,
                  fontWeight: 700,
                  color: '#fff',
                  letterSpacing: 1,
                }}
                src='/assets/images/banks/tpbank.png'
                alt='TPBank'
              />
              <div style={{ color: '#fff', fontWeight: 600, fontSize: 14 }}>
                TPBank
              </div>
            </div> */}

            <div
              onClick={() => {
                setIsShowBankSelectModal(false);
                navigate(MainRouteKeys.TransfersToBankBIDV);
              }}
              style={{
                cursor: 'pointer',
                border: '2px solid #353570',
                borderRadius: 12,
                padding: '24px 32px',
                textAlign: 'center',
                minWidth: 140,
                background: '#1d1d42',
                transition: 'border-color 0.2s',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.borderColor = '#4caf50')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.borderColor = '#353570')
              }
            >
              <img
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: 8,
                  background: '#0066CC',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 12px',
                  fontSize: 18,
                  fontWeight: 700,
                  color: '#fff',
                  letterSpacing: 1,
                }}
                src='/assets/images/banks/bidv.png'
                alt='BIDV'
              />
              <div style={{ color: '#fff', fontWeight: 600, fontSize: 14 }}>
                BIDV
              </div>
            </div>
          </div>
        </PopupWraper>
      )}
    </div>
  );
};

export default BalanceManagementFeatures;
